import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { Children } from 'react';
import Box from '../Box';
import DragDrop from '../DragDrop';
import GridView from '../GridView';
import HeadingUppercase from '../HeadingUppercase';
import { cloneChildren } from '../utils';
import { SORTABLE_TYPE } from './constants';
import SortableEmpty from './SortableEmpty';
import { SORTABLE_ITEM_DISPLAY_NAME } from './SortableItem';

function SortableList(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      emptyText = _ref.emptyText,
      id = _ref.id,
      onItemRemoveRequest = _ref.onItemRemoveRequest,
      title = _ref.title,
      readOnly = _ref.readOnly,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "disabled", "emptyText", "id", "onItemRemoveRequest", "title", "readOnly"]);

  var childCount = Children.count(children);
  return /*#__PURE__*/React.createElement(Box, restProps, title && /*#__PURE__*/React.createElement(HeadingUppercase, {
    padding: 1,
    backgroundColor: "surfaceSecondary",
    borderBottomWidth: 1,
    borderBottomColor: "separatorTertiary"
  }, title), /*#__PURE__*/React.createElement(DragDrop.Droppable, {
    type: SORTABLE_TYPE,
    isDropDisabled: disabled || readOnly,
    droppableId: id
  }, function (provided, snapshot) {
    return /*#__PURE__*/React.createElement(GridView, _extends({
      innerRef: provided.innerRef,
      minHeight: 5,
      backgroundColor: "surfaceSecondary",
      position: "relative",
      css: emptyText && childCount <= 0 ? {
        '[data-rbd-placeholder-context-id]': {
          column: 1,
          row: 1
        }
      } : undefined
    }, provided.droppableProps), emptyText && childCount <= 0 && /*#__PURE__*/React.createElement(SortableEmpty, {
      emptyText: emptyText,
      isDraggingOver: snapshot.isDraggingOver
    }), cloneChildren(children, function (child, _ref2) {
      var index = _ref2.index;
      var childProps = {
        pointerEvents: snapshot.isDraggingOver ? 'none' : undefined
      };

      if (index !== 0) {
        childProps.borderTopWidth = 1;
        childProps.borderTopColor = 'separatorTertiary';
      }

      if (child && child.type.displayName === SORTABLE_ITEM_DISPLAY_NAME) {
        childProps.index = index;

        if (!readOnly && !snapshot.isDraggingOver && (onItemRemoveRequest || child.props.onRemoveRequest)) {
          childProps.onRemoveRequest = function (e) {
            var itemPayload = {
              id: id,
              index: index
            };

            if (onItemRemoveRequest) {
              onItemRemoveRequest(itemPayload, e);
            }

            if (child.props.onRemoveRequest) {
              child.props.onRemoveRequest(itemPayload, e);
            }
          };
        }
      }

      return childProps;
    }), provided.placeholder);
  }));
}

export default SortableList;